module.exports = __webpack_public_path__ + "static/media/return_sound.e68b9dc6.mp3";